import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { SysAdminService } from "../../services/sysadmin.service";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolService } from "../../../../shared/services/school.service";

@Component({
	selector: "app-mfa-toggle",
	templateUrl: "./mfa-toggle.component.html",
	styleUrls: ["./mfa-toggle.component.css"],
})
export class MfaToggleComponent implements OnInit {
	constructor(
		private schoolService: SchoolService,
		private ref: DynamicDialogRef,
		private sysAdminService: SysAdminService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.loadSchool();
	}

	///////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////

	Processing: boolean = false;

	subscription: any;

	LoadingSchool: boolean = false;
	lstSchool: any = [];
	School: any;

	MFAEnabled: boolean = false;
	ResetRegistration: boolean = true;

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////

	loadSchool() {
		this.LoadingSchool = true;

		var result = this.schoolService.loadSchoolListWithOptions("", -1);
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				if (this.lstSchool.length > 0) {
					this.School = this.lstSchool[0];
				}

				this.LoadingSchool = false;
			},
			(error) => {
				this.LoadingSchool = false;
			}
		);
	}

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////
	onUpdate() {
		this.Processing = true;

		var result = this.sysAdminService.UsersToggleAllMFA(this.School.SchoolID, this.MFAEnabled == true ? 1 : 0, this.ResetRegistration == true ? 1 : 0);
		result.subscribe(
			(response) => {
				//Success Dialog
				this.confirmationService.confirm({
					key: "togglemfa",
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "MFA Settings Updated Successfully.",
					header: "Success",
					icon: "fa",
					accept: () => {
						this.ref.close(1);
					},
				});
			},
			(error) => {
				//Fail Dialog
				this.confirmationService.confirm({
					key: "togglemfa",
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "Could Not Update MFA Settings for " + this.School.SchoolFullName,
					header: "ERROR",
					icon: "fa",
					accept: () => {
						this.Processing = false;
					},
				});
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingSchool == true || this.Processing == true;
	}

	///////////////////////////////////////////////////////////
}
